import { useEffect, useRef, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import LoginPage from "@/pages/LoginPage";
import AuthCallback from "@/pages/AuthCallback";
import MapDashboard from "@/pages/MapDashboard";
import DashboardPage from "@/pages/DashboardPage";
import CarnetPage from "@/pages/CarnetPage";
import SubscriptionPage from "@/pages/SubscriptionPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import ConventionsPage from "@/pages/ConventionsPage";
import AccountPage from "@/pages/AccountPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import VerifyEmailPage from "@/pages/VerifyEmailPage";
import ControleRegistrePage from "@/pages/ControleRegistrePage";
import MyParcelsPage from "@/pages/MyParcelsPage";
import FicheParcellePage from "@/pages/FicheParcellePage";
import ExtractionParcellePage from "@/pages/ExtractionParcellePage";
import ProtectedRoute from "@/components/ProtectedRoute";
import PWAInstall from "@/components/PWAInstall";
import ExtractionQueue from "@/components/ExtractionQueue";
import { Toaster } from "@/components/ui/sonner";

import ErrorBoundary from "@/components/ErrorBoundary";
function AppRouter() {
  const location = useLocation();

  // CRITICAL: Check URL fragment for session_id synchronously during render
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<LoginPage />} />
      <Route path="/inscription" element={<LoginPage initialMode="register" />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/verify-email" element={<VerifyEmailPage />} />
      <Route path="/controle/:token" element={<ControleRegistrePage />} />
      <Route
        path="/subscription"
        element={
          <ProtectedRoute requireSubscription={false}>
            <SubscriptionPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/subscription/success"
        element={
          <ProtectedRoute requireSubscription={false}>
            <SubscriptionPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/conventions"
        element={
          <ProtectedRoute requireSubscription={false}>
            <ConventionsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin-dashboard"
        element={
          <ProtectedRoute requireSubscription={false}>
            <AdminDashboardPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute requireSubscription={false}>
            <DashboardPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/map"
        element={
          <ProtectedRoute requireSubscription={false}>
            <MapDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/carnet/:parcelId"
        element={
          <ProtectedRoute requireSubscription={false}>
            <CarnetPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/account"
        element={
          <ProtectedRoute requireSubscription={false}>
            <AccountPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/parcelles"
        element={
          <ProtectedRoute requireSubscription={false}>
            <MyParcelsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/parcelles/:parcelId/fiche"
        element={
          <ProtectedRoute requireSubscription={false}>
            <FicheParcellePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/parcelles/:parcelId/extraction"
        element={
          <ProtectedRoute requireSubscription={false}>
            <ExtractionParcellePage />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <>
      <BrowserRouter>
        <ErrorBoundary>
          <AppRouter />
        </ErrorBoundary>
        <PWAInstall />
        <ExtractionQueue />
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </>
  );
}

export default App;
